import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { CgWebsite } from "react-icons/cg";
import { BsGithub } from "react-icons/bs";

function ProjectCards(props) {
  return (
    <Card className="project-card-view">
      <Card.Img
        variant="top"
        src={props.imgPath}
        alt="card-img"
        style={{
          height: "200px",
          objectFit: "contain",
          padding: "20px",
          backgroundColor: "transparent"
        }}
      />
      <Card.Body style={{ position: "relative", zIndex: 10 }}>
        <Card.Title>{props.title}</Card.Title>
        <Card.Text style={{ textAlign: "justify" }}>
          {props.description}
        </Card.Text>

        <Button
          variant="primary"
          href={props.ghLink}
          target="_blank"
          style={{
            marginLeft: "10px",
            position: "relative",
            zIndex: 100,
            pointerEvents: "auto",
            cursor: "pointer"
          }}
        >
          <BsGithub /> &nbsp;
          {props.isBlog ? "Blog" : "GitHub"}
        </Button>

        {!props.isBlog && props.demoLink && (
          <Button
            variant="primary"
            href={props.demoLink}
            target="_blank"
            style={{
              marginLeft: "10px",
              position: "relative",
              zIndex: 100,
              pointerEvents: "auto",
              cursor: "pointer"
            }}
          >
            <CgWebsite /> &nbsp;
            {"Demo"}
          </Button>
        )}
      </Card.Body>
    </Card>
  );
}

export default ProjectCards;